"use strict";

var _classCallCheck = require("/tmp/build_2b6a6b3d/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_2b6a6b3d/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/tmp/build_2b6a6b3d/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/tmp/build_2b6a6b3d/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LexiconEditor = void 0;

var react_1 = __importDefault(require("react"));

require("../styles/LexiconEditorStyles.scss");

var collection_1 = require("./collection");

function LocaleChooser(_ref) {
  var lexicon = _ref.lexicon,
      switchLocale = _ref.switchLocale,
      selectedLocale = _ref.selectedLocale;
  return lexicon.locales().map(function (locale) {
    return react_1.default.createElement("label", {
      htmlFor: "localeRadio__".concat(locale),
      key: locale
    }, react_1.default.createElement("input", {
      type: "radio",
      id: "localeRadio__".concat(locale),
      value: locale,
      checked: locale == selectedLocale,
      onChange: function onChange(e) {
        return switchLocale(e.target.value);
      }
    }), locale);
  });
}

var FormRow = function FormRow(props) {
  return react_1.default.createElement("div", {
    id: "FormRow"
  }, react_1.default.createElement("label", {
    title: props.label
  }, react_1.default.createElement("span", {
    className: "label"
  }, props.label), props.children));
};

var Field = function Field(_ref2) {
  var localPath = _ref2.localPath,
      value = _ref2.value,
      onChange = _ref2.onChange;
  return react_1.default.createElement("textarea", {
    name: localPath,
    value: value,
    onChange: onChange
  });
};

var LexiconEditor = /*#__PURE__*/function (_react_1$default$Comp) {
  _inherits(LexiconEditor, _react_1$default$Comp);

  var _super = _createSuper(LexiconEditor);

  function LexiconEditor() {
    var _this;

    _classCallCheck(this, LexiconEditor);

    _this = _super.apply(this, arguments);

    _this.sendLexiconEditorChange = function (event) {
      var _event$target = event.target,
          localPath = _event$target.name,
          newValue = _event$target.value;

      var source = _this.props.lexicon.source(localPath);

      var changeInfo = {
        filename: source.filename,
        localPath: collection_1.keyPathAsString(source.localPath),
        updatePath: collection_1.keyPathAsString(source.updatePath),
        newValue: newValue
      };

      _this.props.onChange(changeInfo);
    };

    return _this;
  }

  _createClass(LexiconEditor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return react_1.default.createElement("div", {
        id: "LexiconEditor"
      }, react_1.default.createElement(LocaleChooser, {
        lexicon: this.props.lexicon,
        selectedLocale: this.props.selectedLocale,
        switchLocale: this.props.switchLocale
      }), this.props.lexicon.keys().map(function (key) {
        return react_1.default.createElement(FormRow, {
          key: key,
          label: key
        }, react_1.default.createElement(Field, {
          localPath: key,
          value: _this2.props.lexicon.get(key),
          onChange: _this2.sendLexiconEditorChange
        }));
      }));
    }
  }]);

  return LexiconEditor;
}(react_1.default.Component);

exports.LexiconEditor = LexiconEditor;